export const contact = {
  phone: '+91 98861 70470 / 080 23381091',
  email: 'info@shreebhavaniinstitutions.com',
  corporateAddress: '18, 17th Main Rd, Srinagar, Banashankari, Bengaluru – 560050',
  campusAddress: '10th Main Rd, KP Agrahara, Cottonpete, Bengaluru – 560023',
};

export const nav = [
  ['About', 'about'], ['Curriculum', 'curriculum'], ['Admission', 'admission'],
  ['Fees', 'fees'], ['Internship', 'internship'], ['Gallery', 'gallery'], ['Careers', 'careers'],
];

export const glance = [
  ['Degree', 'Bachelor of Physiotherapy (BPT)'],
  ['Affiliation', 'RGUHS, Karnataka'],
  ['Duration', '4 years plus 6 months internship'],
  ['Mode', 'Full-time, regular'],
  ['Location', 'Bangalore, Karnataka'],
];

export const years = [
  { year: 'First Year', title: 'Basic Sciences', text: 'Students learn how the human body is built and how it functions.', subjects: ['Anatomy', 'Physiology', 'Biochemistry', 'Psychology', 'Sociology'] },
  { year: 'Second Year', title: 'Core Physiotherapy', text: 'Laboratory sessions and clinical observation add practical experience.', subjects: ['Biomechanics', 'Exercise Therapy', 'Electrotherapy', 'Pathology', 'Microbiology', 'Pharmacology'] },
  { year: 'Third Year', title: 'Clinical Subjects', text: 'Students learn to understand patient conditions and plan suitable physiotherapy treatment.', subjects: ['Orthopaedics', 'Neurology', 'General Medicine', 'General Surgery', 'Physical Diagnosis'] },
  { year: 'Fourth Year', title: 'Specialised Physiotherapy', text: 'More clinical experience, plus research activities.', subjects: ['Musculoskeletal Physiotherapy', 'Neurological Physiotherapy', 'Cardiopulmonary Physiotherapy', 'Paediatric Physiotherapy', 'Sports Physiotherapy', 'Community Rehabilitation', 'Research Methodology', 'Biostatistics', 'Ethics', 'Administration'] },
];

export const teaching = ['Classroom lectures', 'Practical sessions', 'Laboratory training', 'Case studies', 'Seminars', 'Workshops', 'Supervised hospital postings'];

export const eligibility = [
  'Successful completion of 10+2 / PUC with Physics, Chemistry and Biology',
  'Minimum aggregate marks in the qualifying examination as prescribed by RGUHS and the state government',
  'Minimum age of 17 years at the time of admission',
];

export const steps = [
  ['Enquiry and registration', 'Contact the SBGI admission office or submit an enquiry through the website.'],
  ['Document submission', '10th and 12th marks cards, transfer certificate, ID proof, passport-size photographs and, where applicable, caste or income certificates.'],
  ['Verification', 'The admission team checks eligibility and merit.'],
  ['Seat confirmation', 'Pay the prescribed fee to confirm your seat.'],
  ['Reporting', 'Join the college on the date announced in the academic calendar.'],
];

export const concessions = [['80% and above', '₹50,000'], ['70% and above', '₹25,000']];

export const rotations = [
  'Orthopaedics and Sports Medicine', 'Neurology and Neurosurgery', 'Cardiothoracic and Pulmonary Rehabilitation',
  'Paediatrics and Developmental Therapy', 'Intensive Care and Critical Care', 'Community-based Rehabilitation',
];

export const placement = [
  'Campus recruitment drives with hospitals and healthcare organisations', 'Career counselling and individual guidance',
  'Resume preparation and interview support', 'Soft-skills and communication training',
  'Guidance for higher studies such as MPT', 'Support and guidance for competitive examinations',
];

export const careers = [
  'Hospitals and multi-speciality clinics', 'Physiotherapy and rehabilitation centres', 'Sports academies and fitness centres',
  'Professional sports teams', 'Geriatric and home-care services', 'Paediatric and neuro-rehabilitation centres',
  'Private physiotherapy practice', 'Teaching and academic institutions', 'Research and healthcare organisations',
];

export const higherStudies = ['Master of Physiotherapy (MPT)', 'Specialised physiotherapy programmes', 'Research and academic programmes', 'Other healthcare-related courses'];

export const why = [
  ['Over two decades of experience', 'Health sciences education since 2003.'],
  ['Recognised affiliations', 'RGUHS, the Karnataka State Paramedical Board and the Karnataka State Nursing Council.'],
  ['Hands-on clinical training', 'Supervised practice in hospital settings.'],
  ['Academic support', 'A college library and modern facilities.'],
  ['Merit-based concessions', 'Up to ₹50,000 on the BPT programme.'],
  ['Value-based education', 'Character is developed along with clinical skill.'],
];
